import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'FISCAL_YEAR_PRINT_ERROR':
      return action.error;

    case 'FISCAL_YEAR_PRINT_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'FISCAL_YEAR_PRINT_LOADING':
      return action.loading;

    case 'FISCAL_YEAR_PRINT_RESET':
      return false;

    default:
      return state;
  }
}

export function url(state = {}, action) {
  switch (action.type) {
    case 'FISCAL_YEAR_PRINT_SUCCESS':
      return action.retrieved;

    case 'FISCAL_YEAR_PRINT_RESET':
      return {};

    default:
      return state;
  }
}

export default combineReducers({
  error, loading, url,
});
